import * as React from 'react';
import type AnalyticsEvent from '@atlaskit/analytics-next/AnalyticsEvent';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import {
	fireScreenAnalytics,
	fireAnalytics,
} from '@atlassian/analytics-bridge/fire-analytics/fire-analytics';
import { UI_EVENT_TYPE } from '@atlassian/analytics-bridge/constants';
import { MountEvent } from '@atlassian/analytics-bridge/mount-event';
import type { ScreenName } from '@helpcenter/constants';
import {
	isPageLoadInstrumented,
	perfConfig,
} from '@atlassian/help-center-common-util/analytics/perf-config';
import { devLog } from '@atlassian/help-center-common-util/dev-logger';
import { perfMark } from '../browser-metrics-v3';
import { AnalyticsTrackActions } from '../events';

export interface FireScreenEventOnMountStatelessProps {
	screenName: ScreenName | undefined;
	screenId?: string | number;
	customData?: object;
}

export class FireScreenEventOnMountStateless extends React.Component<FireScreenEventOnMountStatelessProps> {
	endBrowserMetricsV3 = (screenName: ScreenName) => {
		const { customData } = this.props;

		// @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
		// Suppressing existing violation. Please fix this.
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		const metric = perfConfig[screenName];

		/**
		 * This is used to support the previously created performance mark
		 */
		perfMark('second.data.loaded');
		devLog('Browser Metrics v3: ending timer and firing event for screen:', screenName);

		// Suppressing existing violation. Please fix this.
		// eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
		metric.stop({
			customData,
		});
	};

	onMount = (analyticsEvent: AnalyticsEvent) => {
		const { screenName } = this.props;

		fireScreenAnalytics(analyticsEvent, AnalyticsTrackActions.VIEWED);

		/**
		 * Fire jsm-ui viewed event along with screen event
		 * 1. This is done to for anti abuse spam work to detect human or bot spam
		 * 2. We are firing this instead of `ui viewed` because that event is used for overall Atlassian MAU calculations.
		 * 3. Event registration -> https://data-portal.internal.atlassian.com/analytics/registry/59264?tabIndex=Details
		 */
		const uiAnalyticsEvent = analyticsEvent.clone() as UIAnalyticsEvent;
		fireAnalytics(uiAnalyticsEvent, UI_EVENT_TYPE, {
			actionSubject: 'jsm-ui',
			action: AnalyticsTrackActions.VIEWED,
		});

		/**
		 * Trigger Stop timer for for Page load metric only if
		 * 1. screenName exists
		 * 2. metrics is instrumented for that screen
		 * 3. BM3 feature flag is enabled
		 */

		if (screenName && isPageLoadInstrumented(screenName)) {
			this.endBrowserMetricsV3(screenName);
		}
	};

	render() {
		return (
			<MountEvent
				onMount={this.onMount}
				// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
				key={`${this.props.screenName}-${this.props.screenId}`}
			/>
		);
	}
}
